var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"auth-button-doxy",attrs:{"x-large":"","width":"100%","outlined":"","height":_vm.$vuetify.breakpoint.smAndUp ? 64 : 60},on:{"click":_vm.signInAndRedirect}},[_c('img',{staticClass:"mr-6 mr-sm-4",attrs:{"src":require("@/assets/doxyme.svg"),"alt":"doxyme","width":"32","height":"32"}}),_vm._v(" Continue with Doxy.me ")])
}
var staticRenderFns = []

export { render, staticRenderFns }